import Cookies from 'js-cookie'

const TokenKey = 'token'
const TempTokenKey = 'temptoken'
const AppIdKey = 'appId'

const IosScheme = 'ios_scheme'


export function getToken() {
  return Cookies.get(TokenKey)
}
export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getTempToken() {
  return Cookies.get(TempTokenKey)
}
export function setTempToken(token) {
  return Cookies.set(TempTokenKey, token)
}
export function removeTempToken() {
  return Cookies.remove(TempTokenKey)
}

export function getAppId() {
  return Cookies.get(AppIdKey)
}
export function setAppId(appId) {
  return Cookies.set(AppIdKey, appId)
}
export function removeAppId() {
  return Cookies.remove(AppIdKey)
}


export function geIosScheme() {
  return Cookies.get(IosScheme)
}
export function seIosScheme(Ios_scheme) {
  return Cookies.set(IosScheme, Ios_scheme)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js